/**
 * PGSS-5873: the toast after Approve / Reject / Dispatch Shipment.
 *
 * PUT /api/shipment/{id} answers 200 with `changed: false` when it refused to touch the container (it was no longer
 * waiting for approval). That used to read "Shipment has been rejected" too, so staff took a no-op for a reject.
 * Any other 200 keeps the old message.
 */
export function shipmentApprovalMessage(params, data) {
  if (data?.changed === false) {
    return { type: 'warning', message: data.shipment || 'Nothing was changed' };
  }
  let message = params?.is_approve ? 'approved' : 'rejected';
  if (params?.is_approve === null || params?.is_approve === undefined) message = 'dispatched';
  return { type: 'success', message: `Shipment has been ${message}` };
}
